export const parseQueryParam = <T extends {}>(queryParam: string): T =>
  JSON.parse(queryParam)

export const toQueryParam = <T extends {}>(state: T): string => JSON.stringify(state)

export const saveState = <T extends {}>(localStorageKey: string, state: T) => {
  localStorage.setItem(localStorageKey, JSON.stringify(state))
}

export const getSavedState = <T extends {}>(localStorageKey: string, defaultState: T) => {
  const savedState = localStorage.getItem(localStorageKey)

  if (savedState === null || savedState === undefined) {
    return defaultState
  }

  return parseQueryParam(savedState)
}
